import React from "react";
import { Accordion as Accordion$1 } from "@base-ui/react/accordion";
import { IconArrowRight } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/Accordion/index.tsx
const Accordion = ({ title, children, className, initialOpen = false, open, onOpenChange, value: initialValue, actions }) => {
	const [value] = React.useState(initialValue ?? Math.random().toString());
	const isControlled = open !== void 0;
	const [internalOpen, setInternalOpen] = React.useState(initialOpen);
	const isOpen = isControlled ? open : internalOpen;
	const setOpen = React.useCallback((nextOpen) => {
		if (isControlled) onOpenChange?.(nextOpen);
		else setInternalOpen(nextOpen);
	}, [isControlled, onOpenChange]);
	const handleToggle = React.useCallback(() => {
		setOpen(!isOpen);
	}, [isOpen, setOpen]);
	return /* @__PURE__ */ jsx(Accordion$1.Root, {
		multiple: false,
		value: isOpen ? [value] : [],
		onValueChange: (nextValue) => setOpen(nextValue.includes(value)),
		children: /* @__PURE__ */ jsxs(Accordion$1.Item, {
			value,
			className: cn("border-neutrals-90 overflow-hidden rounded-[0.875rem] border-2 bg-white", className),
			children: [/* @__PURE__ */ jsxs(Accordion$1.Header, {
				className: "flex items-center",
				children: [/* @__PURE__ */ jsx(Accordion$1.Trigger, {
					className: cn("font-inherit flex min-w-0 flex-1 cursor-pointer flex-nowrap border-0 bg-transparent px-4 py-2 text-left", "outline-none focus-visible:outline-none"),
					children: /* @__PURE__ */ jsx("div", {
						className: "flex min-w-0 flex-1 items-center",
						children: title
					})
				}), /* @__PURE__ */ jsxs("div", {
					className: "flex shrink-0 items-center gap-2 self-center pr-3",
					children: [actions, /* @__PURE__ */ jsx("button", {
						type: "button",
						"aria-expanded": isOpen,
						"aria-label": isOpen ? "Свернуть" : "Раскрыть",
						onClick: handleToggle,
						className: "flex shrink-0 cursor-pointer items-center justify-center rounded-lg p-2 outline-none focus-visible:outline-none",
						children: /* @__PURE__ */ jsx(IconArrowRight, { className: cn("text-neutrals-60 size-6 shrink-0 transition-transform", isOpen && "rotate-90") })
					})]
				})]
			}), /* @__PURE__ */ jsx(Accordion$1.Panel, {
				className: cn("px-4 py-2"),
				children
			})]
		})
	});
};
//#endregion
export { Accordion };

//# sourceMappingURL=index.js.map